import { create } from 'zustand';

const useUserMode = create(set => ({
  userMode: 'select',
  setUserMode: userMode => set({ userMode }),
}));

export default useUserMode;